export type FontFamilyType = {
  readonly PRIMARY: string,
};

export type FontSizeType = {
  readonly XS: string,
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
};

export type FontWeightType = {
  readonly SM: number,
  readonly MD: number,
  readonly LG: number,
  readonly XL: number,
  readonly XXL: number,
};

export type FontSizeCodeType = {
  readonly XS: string,
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
};

export type FontWeightCodeType = {
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
  readonly XXL: string,
};

export type FontStyleType = {
  readonly FAMILY: FontFamilyType,
  readonly SIZE: FontSizeType,
  readonly WEIGHT: FontWeightType,
  readonly NEXT_SIZE_CODE: FontSizeCodeType,
  readonly PRIOR_SIZE_CODE: FontSizeCodeType,
  readonly NEXT_WEIGHT_CODE: FontWeightCodeType,
  readonly PRIOR_WEIGHT_CODE: FontWeightCodeType,
};

export const FONT_STYLE: FontStyleType = Object.freeze({
  FAMILY: Object.freeze({
    PRIMARY: 'Inter, sans-serif',
  }),
  SIZE: Object.freeze({
    XS: '10px',
    SM: '12px',
    MD: '14px',
    LG: '24px',
    XL: '40px',
  }),
  WEIGHT: Object.freeze({
    SM: 300,
    MD: 400,
    LG: 500,
    XL: 700,
    XXL: 800,
  }),
  NEXT_SIZE_CODE: Object.freeze({
    XS: 'SM',
    SM: 'MD',
    MD: 'LG',
    LG: 'XL',
    XL: 'XL',
  }),
  PRIOR_SIZE_CODE: Object.freeze({
    XS: 'XS',
    SM: 'XS',
    MD: 'SM',
    LG: 'MD',
    XL: 'LG',
  }),
  NEXT_WEIGHT_CODE: Object.freeze({
    SM: 'MD',
    MD: 'LG',
    LG: 'XL',
    XL: 'XXL',
    XXL: 'XXL',
  }),
  PRIOR_WEIGHT_CODE: Object.freeze({
    SM: 'SM',
    MD: 'SM',
    LG: 'MD',
    XL: 'LG',
    XXL: 'XL',
  }),
});
